import { CommonErrorCode } from '~commonInfra/utils/ErrorCodes';
import { LoginUrlsWrapper } from '~src/authentication/components/loginSpace/LoginUrls';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { WindowLocationService } from '~src/commonInfra/services/WindowLocationService';

import { AuthenticationTypeResolutionService } from './AuthenticationTypeResolutionService';

export namespace UnauthenticatedUserHandler {

  // Anonymous is an angular state concept that means the user doesn't
  // have to be authenticated to view this url.
  export function isAnonymousUrl(url: string): boolean {
    const loginUrls = LoginUrlsWrapper.getInstance();
    return url.includes('/#/authenticate')
      || url.includes(loginUrls.signinPath())
      || url.includes(loginUrls.signinErorrCodePath(''))
      || url.includes(loginUrls.signedOutPath())
      || url.includes(loginUrls.siteSamlSignedOutPath())
      || url.includes(loginUrls.passwordResetUserNameBasePath())
      || url.includes(loginUrls.requestPasswordResetPath())
      || url.includes('/#/pkce/');
  }

  export function handle401(reason: number) {
    // If 1...we are not in a state (i.e. app has not bootstrapped)
    // or 2...we are in an anonymous state
    // or 3...the api responds 'Permission Denied' (NOT session expired)
    if (getAppStore().getState().rootAdminUiState !== 'default' ||
      isAnonymousUrl(WindowLocationService.getHref()) ||
      reason === CommonErrorCode.CallingUserInsufficientPermissions) {
      return;
    }
    if (AuthenticationTypeResolutionService.isAuthenticationAutoLogin() ||
          AuthenticationTypeResolutionService.isAuthenticationExternal()) {
      // For these auth types we can't give an error message that the user's session expired
      // so just refresh the page and let vizportal re-bootstrap and re-authenticate
      WindowLocationService.reload();
    } else {
      // For other auth types we can give a "session expired" error message, so do that
      const redirectPath = WindowLocationService.getPathQueryFragment();
      const href = LoginUrlsWrapper.getInstance().signinUrl({
        redirect: redirectPath ? redirectPath.replace(/^\/#/, '') : null,
        error: reason || CommonErrorCode.InvalidSession,
      });
      // We must remove the hash so the browser does a full page load. The /signin route is a special
      // route that apache will rewrite to /#/signin with query params intact
      WindowLocationService.navigateTo(href.replace(/^#/, ''));
    }
  }
}

export type UnauthenticatedUserHandler = typeof UnauthenticatedUserHandler;
